import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';

import React from 'react';
import { Router, Link, browserHistory } from 'react-router';

import MgfForm from '../common/mgfForm';
import { MontgolfiereSchema, Montgolfieres } from '../../collections/montgolfieres/montgolfieres';

import {
  BPanel,
  Table,
  Button,
  Form,
  FormGroup,
  Col,
  Checkbox,
  ControlLabel,
  FormControl,
  Breadcrumb,
  BreadcrumbItem
} from '@sketchpixy/rubix';

export default class MontgolfiereAddPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}	

	handleSubmit(doc) {
		this.context.router.push('/montgolfieres');
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/montgolfieres">Montgolfieres</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Ajouter une montgolfiere
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Ajouter une montgolfiere">
					<MgfForm schema={MontgolfiereSchema} collection={Montgolfieres} onSubmit={this.handleSubmit.bind(this)} />
				</BPanel>
			</div>
		);
	}
}

MontgolfiereAddPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/montgolfieres/MontgolfiereAdd.page.js
 **/